import { api as wiredApi } from './index';

/**
 * What a rider earned and owes, on InGo's API (ingo-e0, 2 Oct 2026; InGo ADR
 * 0030): read from the commission line written once at each completion,
 * never worked out here. The old screens added up Supabase's bookings and took
 * the commission off in the browser at today's rate.
 *
 * Built from its client so a test can hand it a fake; `earningsApi` is the
 * wired copy.
 */
export function createEarnings({ api }) {
  return {
    /**
     * `GET rider/me/earnings?period=today|week|month`: the period in the
     * operator's calendar, its totals in minor units, and each delivery's
     * fare, commission and what the rider kept, newest first.
     */
    async earnings(period) {
      const { data } = await api.get('/rider/me/earnings', { query: { period } });

      return data;
    },

    /**
     * `GET rider/me/wallet`: the cash collected and the commission on it owed
     * to InGo, since the first delivery, with a page of lines; `before` is the
     * cursor the last page gave (`next`).
     */
    async wallet(before = null) {
      const { data, meta } = await api.get('/rider/me/wallet', before ? { query: { before } } : undefined);

      return { ...data, next: meta?.cursor?.next ?? null };
    },

    /**
     * `POST rider/me/remittances` (InGo ADR 0033): the rider says what they
     * paid the office; it waits until the office confirms or declines it.
     * Refused while one already waits, or for more than is owed.
     */
    async remit(amountMinor, note = '') {
      const said = String(note ?? '').trim();
      const { data, message } = await api.post('/rider/me/remittances', said ? { amount_minor: amountMinor, note: said } : { amount_minor: amountMinor });

      return { remittance: data, message };
    },
  };
}

export const earningsApi = createEarnings({ api: wiredApi });
